import BootstrapVue from 'bootstrap-vue';
import Vue from 'vue';
import VueGtag from 'vue-gtag';
import { vueVimeoPlayer } from 'vue-vimeo-player';
import VueMarqueeSlider from 'vue-marquee-slider';
import VueWaypoint from 'vue-waypoint';
import App from './app.vue';
import MainNav from './components/main-nav.vue';
import SecondaryNav from './components/secondary-nav.vue';
import FooterRow from './components/footer.vue';
import AlertRow from './components/alert.vue';
import LoadingScreen from './components/loading.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './styles/main.scss';

const { NODE_ENV, VUE_APP_GTAG_ID } = process.env;

Vue.config.productionTip = NODE_ENV === 'production';

Vue.use(BootstrapVue);
Vue.use(VueMarqueeSlider);
Vue.use(VueWaypoint);
Vue.component('vimeo-player', vueVimeoPlayer);

Vue.component('main-nav', MainNav);
Vue.component('secondary-nav', SecondaryNav);
Vue.component('footer-row', FooterRow);
Vue.component('alert-row', AlertRow);
Vue.component('loading-screen', LoadingScreen);

if (VUE_APP_GTAG_ID) {
  Vue.use(VueGtag, { config: { id: VUE_APP_GTAG_ID } }, router);
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
